module.exports = __webpack_public_path__ + "media/packs/images/flags/SK-05d586b74d17fd47b00d3c387548bea8.png";